export const getSignalsUrl = (locationId: string, agentId: string) =>
  `/business/locations/${locationId}/agents/${agentId}/signals`;

export const getDefaultSentimentKeywordsUrl = () => 'business/sentiment_keywords/default_keywords';

export const getGenerateSentimentKeywordsUrl = () => 'business/sentiment_keywords/generate_keywords';

export const getSentimentSummaryUrl = (locationId: string, agentId: string) =>
  `${getSignalsUrl(locationId, agentId)}/sentiment_summary`;

export const getBreakdownUrl = (locationId: string, agentId: string) =>
  `${getSignalsUrl(locationId, agentId)}/breakdown`;

export const getTopKeywordsUrl = (locationId: string, agentId: string) =>
  `${getSignalsUrl(locationId, agentId)}/top_keywords`;
